import flagKeys from '@/constants/flagKeys';
import { app } from '@/main';

export const getMenuIconName = (name: string) => {
  if (app.$store.getters['flags/getFlags'].includes(flagKeys.newCoinIcon)) {
    if (name === 'welcome-coins') return 'welcome-coins-v2';
    if (name === 'special-coin') return 'offers';

    return name;
  }

  return name;
};
